interface Props {
	onClick: () => void;
}

export default function Backdrop({onClick}: Props) {
	return (
		<div
			role='button'
			tabIndex={0}
			className='fixed z-20 inset-0 bg-black opacity-30 transition-opacity duration-500 ease-in-out overflow-hidden h-full'
			onClick={onClick}
		/>
	);
}
